import { useTranslation } from 'react-i18next'

import { PageEmptyState } from '../../../PageEmptyState'

import StatisticIcon from '../../../../icons/statistic.svg'

function RentalPortalOverviewNoScope() {
  const { t } = useTranslation()

  return (
    <PageEmptyState
      EntityIcon={StatisticIcon}
      text={t('RentalPortal.OverviewEmptyNoScopeKey')}
    />
  )
}

export default RentalPortalOverviewNoScope
